export const socketUrls = {
  base: '/api/2/ws/v2/events',
};
